import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AuthorizerVO} from '../../../generate/TldChangeResultVO';
import {AppConfigService} from "../../../services/app.config.service";

@Component({
  selector: 'authorizers-list-block',
  templateUrl: './authorizers-list-block.component.html',
  styleUrls: ['./authorizers-list-block.component.scss']
})
export class AuthorizersListBlockComponent implements OnInit {

  @Input()
  userInterFace: boolean;

  @Input()
  authorizers: Array<AuthorizerVO>;

  @Input()
  currentUserID: string;

  @Input()
  currentProcess: string;

  @Output()
  authorize = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit() {
  }

  navigateToAuthorizeRequestPage(authorizer: AuthorizerVO) {
    this.authorize.emit(authorizer.user.id);
  }

  getStatus(status: 'ACCEPT' | 'REJECT' | 'NOOP'): string {
    switch (status) {
      case 'ACCEPT':
        return 'Approved';
      case 'REJECT':
        return 'Rejected';
      case 'NOOP':
        return 'No response yet';

    }
  }

  isContactConfirmationProcess() {
    return this.currentProcess === 'CONTACT_CONFIRMATION';
  }


}
